import { UntilDestroy } from "@ngneat/until-destroy";
import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, tap } from "rxjs/operators";

import { AccountSignatureModel } from "src/app/shared/models/account-signature.model";
import { StateRuleModel } from "src/app/shared/models/state-rules.model";
import { AccountSignatureService } from "src/app/shared/services/account-signature.service";
import { AppSpinnerModule } from "src/app/shared/modules/app-spinner.module";

@UntilDestroy()
@Component({
    selector: 'app-add-signature',
    templateUrl: './add-signature.component.html',
    standalone: false
})
export class AddSignatureComponent implements OnInit {
  mode: "add" | "edit";
  selectedRule: Observable<StateRuleModel>;

  commission: any;
  currentAccountId: number;
  isReadDataFromSassEnabled: boolean = false;
  signatures: AccountSignatureModel[] = [];

  constructor(
    private readonly accountSignatureService: AccountSignatureService,
    private readonly spinner: AppSpinnerModule,
  ) {
  }

  ngOnInit(): void {    
    this.getSignaturesForCurrentUser();
  }

  getSignaturesForCurrentUser(): void {
    this.spinner.show();
    this.accountSignatureService.getCurrentAccountSignatures(this.isReadDataFromSassEnabled, "Uploaded")
      .pipe(
        tap((response) => {
          this.spinner.hide();
          this.signatures = response.accountSignatures;
        }),
        catchError(() => {
            this.spinner.hide();
            return [];
          }
        )).subscribe();
  }
}
